import { Layout } from "./layout";
import { ProtectedRoute } from "./protected-route";

export function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <Layout />
    </ProtectedRoute>
  );
}
